import {
    FETCH_CLIENT_CONTACTS,
    FETCH_SITE_CONTACTS,
    SET_SELECTED_CONTACT
} from '../actions/actionTypes';

const initialState = {
    clientContacts:     [],
    clientContactsMeta: {},
    selectedContact:    {},
    siteContacts:       [],
    siteContactsMeta:   {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CLIENT_CONTACTS:
            return {
                ...state,
                clientContacts:     [...action.payload.data],
                clientContactsMeta: action.payload.meta
            };
        case FETCH_SITE_CONTACTS:
            return {
                ...state,
                siteContacts:     [...action.payload.data],
                siteContactsMeta: action.payload.meta
            };
        case SET_SELECTED_CONTACT:
            return {
                ...state,
                selectedContact: { ...action.payload }
            };
        default:
            return state;
    }
};
